import { ApiInstance } from '@src/services/api-instance';
import { HubEventHandlersService } from './event-handlers/hub-event-handlers';
import { HubWorkflowsService } from './workflows/hub-workflows';

export class HubCrmService {
  private readonly client: ApiInstance;

  public eventHandlers: HubEventHandlersService;
  public workflows: HubWorkflowsService;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/crm`, client.getTimeout());

    this.eventHandlers = new HubEventHandlersService(this.client);
    this.workflows = new HubWorkflowsService(this.client);
  }
}
